import { useQuery } from 'react-query';
import { useFinancialPositionsStore } from '@components/Stores/FinancialPositionStore';
import { useAccountStore } from '@components/Stores/accountStore';
import { getPositions } from '@sp-firebase/financialPositionsFB';

export const useFinancialPositions = () => {
  const { setFinancialPositions } = useFinancialPositionsStore();
  const { account } = useAccountStore();
  const fetchFunction = () => getPositions(account.id || '');

  return useQuery(['Financial-Positions', account.id], fetchFunction, {
    onSuccess: (data) => {
      if (data) {
        setFinancialPositions(data);
      }
    },
    onError: (error) => {
      console.error('Error fetching financial positions:', error);
    },
    enabled: false, //!!account.id,
  });
};
